import React, { useState, useContext } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import summaryApi from '../common/index';
import Context from '../context/index';
import Loading from '../loading';
import { toast } from "react-hot-toast"

const LoginForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { fetchUserDetails, fetchUserAddToCart, fetchUserWishlistCount } = useContext(Context);

  const handleTogglePassword = () => setShowPassword(!showPassword);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const dataResponse = await fetch(summaryApi.signIn.url, {
        method: summaryApi.signIn.method,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const response = await dataResponse.json();

      if (dataResponse.ok && response.success) {
        toast.success("Login Successfully!")

        await fetchUserDetails();
        await fetchUserAddToCart();
        await fetchUserWishlistCount();

        setTimeout(() => {
          toast.dismiss();
          setIsLoading(false);
          navigate('/');
        }, 2000);
      } else {
        toast.error(response.message || 'Failed to login.')
        setIsLoading(false);
      }
    } catch (error) {
      toast.error('An unexpected error occurred.')
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="min-h-screen bg-gradient-to-br from-[#FAF3E0] via-[#F5E6D3] to-[#E8D5B7] flex items-center justify-center px-4 py-12">
          <div className="w-full max-w-md">
            {/* Logo/Brand Section */}
            <div className="text-center mb-8">
              <h1 className="text-4xl md:text-5xl font-extrabold text-[#8B4513] mb-2 tracking-tight">
                Imran and Sons Traders
              </h1>
              <p className="text-[#654321] text-sm md:text-base">Premium Saudi Dates & Attar</p>
            </div>

            {/* Login Card */}
            <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10 border border-[#D4AF37]/20">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">Welcome Back</h2>
              <p className="text-gray-600 text-center mb-8">Sign in to your account to continue</p>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Email Field */}
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={data.email}
                    onChange={handleOnChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 bg-gray-50 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#8B4513] focus:border-transparent transition-all"
                  />
                </div>

                {/* Password Field */}
                <div>
                  <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                    Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      value={data.password}
                      onChange={handleOnChange}
                      required
                      className="w-full px-4 py-3 pr-12 rounded-lg border-2 border-gray-200 bg-gray-50 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#8B4513] focus:border-transparent transition-all"
                    />
                    <button
                      type="button"
                      onClick={handleTogglePassword}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#8B4513] transition-colors"
                    >
                      {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                    </button>
                  </div>
                </div>

                {/* Forgot Password Link */}
                <div className="flex items-center justify-end">
                  <Link 
                    to="/forgot-password" 
                    className="text-sm text-[#8B4513] hover:text-[#654321] font-medium transition-colors"
                  >
                    Forgot Password?
                  </Link>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full py-3.5 bg-[#8B4513] text-white font-bold rounded-lg hover:bg-[#654321] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
                >
                  Sign In
                </button>
              </form>

              {/* Divider */}
              <div className="my-8 flex items-center">
                <div className="flex-1 border-t border-gray-200"></div>
                <span className="px-4 text-sm text-gray-500">or</span>
                <div className="flex-1 border-t border-gray-200"></div>
              </div>

              {/* Sign Up Link */}
              <div className="text-center">
                <p className="text-gray-600 text-sm">
                  Don't have an account?{' '}
                  <Link 
                    to="/SignUp" 
                    className="text-[#8B4513] font-bold hover:text-[#654321] hover:underline transition-colors"
                  >
                    Sign Up
                  </Link>
                </p>
              </div>
            </div>

            {/* Footer Text */}
            <p className="text-center text-gray-500 text-xs mt-6">
              By signing in, you agree to our Terms of Service and Privacy Policy
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginForm;
